import { render, staticRenderFns } from "./centerShow.vue?vue&type=template&id=b13c0ed4&scoped=true&"
import script from "./centerShow.vue?vue&type=script&lang=js&"
export * from "./centerShow.vue?vue&type=script&lang=js&"
import style0 from "./centerShow.vue?vue&type=style&index=0&id=b13c0ed4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13c0ed4",
  null
  
)

export default component.exports